import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sku-settings" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sku_settings_field = _resolveComponent("sku-settings-field")!
  const _component_eye_icon = _resolveComponent("eye-icon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_editable_block = _resolveComponent("editable-block")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    readonly: _ctx.readonly,
    title: "SKU settings",
    "model-value": _ctx.catalogue,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:catalogue', _ctx.catalogue?.sys?.id, $event))),
    "column-count": 1
  }, {
    default: _withCtx(({ editState, editingRef }) => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "description" }, "Custom the SKU format for this channel. This is the code a connected shop will see by default.", -1)),
        _createVNode(_component_sku_settings_field, {
          readonly: _ctx.readonly,
          editing: editingRef.value,
          "onUpdate:editing": ($event: any) => ((editingRef.value) = $event),
          catalogue: editState,
          prefix: editState.sku_prepend,
          "onUpdate:prefix": ($event: any) => ((editState.sku_prepend) = $event),
          separator: editState.sku_separator,
          "onUpdate:separator": ($event: any) => ((editState.sku_separator) = $event),
          suffix: editState.sku_append,
          "onUpdate:suffix": ($event: any) => ((editState.sku_append) = $event)
        }, null, 8, ["readonly", "editing", "onUpdate:editing", "catalogue", "prefix", "onUpdate:prefix", "separator", "onUpdate:separator", "suffix", "onUpdate:suffix"]),
        _createVNode(_component_d_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSkuList = true)),
          flat: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_eye_icon, { left: "" }),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "SKU list", -1))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showSkuList,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showSkuList) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_table, {
            class: "sku-table",
            title: "SKU list",
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
            rows: _ctx.rows,
            columns: _ctx.skuColumns,
            "row-key": "sku",
            separator: "horizontal",
            flat: "",
            bordered: "",
            onRequest: ($event: any) => (_ctx.fetchFromServer($event, editState)),
            ref: "tableRef",
            style: {"width":"50vw","max-width":"none"}
          }, {
            top: _withCtx((props) => [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "q-table__title" }, "SKU list", -1)),
              _createVNode(_component_q_space),
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: "",
                dense: ""
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 2
          }, 1032, ["pagination", "rows", "columns", "onRequest"])
        ]),
        _: 2
      }, 1032, ["modelValue"])
    ]),
    _: 1
  }, 8, ["readonly", "model-value"]))
}